import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { useSelector } from "react-redux";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { PiPottedPlantDuotone } from "react-icons/pi";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { FaCheckCircle } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
const ViewCropUpdate = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [data2, setData2] = useState();
  let { id } = useParams();
  const [imageInfo, setImageInfo] = useState({
    name: "",
    url: "",
  });
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/cropUpdate/getCropUpdateById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          const sortedDataDesc = res.data.cropPhoto.sort((a, b) => {
            const dateA = new Date(a.updateDate);
            const dateB = new Date(b.updateDate);

            if (dateA.getFullYear() !== dateB.getFullYear()) {
              return dateB.getFullYear() - dateA.getFullYear();
            }

            if (dateA.getMonth() !== dateB.getMonth()) {
              return dateB.getMonth() - dateA.getMonth();
            }

            return dateB.getDate() - dateA.getDate();
          });

          setData(res.data);
          setData2(res.data);
        } else {
          Toast("error", "Error while getting crop update!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const getUplodedImage = async (photo, index) => {
    try {
      const res = await performRequest(
        "GET",
        `/fileUploads/getUploadedFile?filename=${photo.cropUploadPhoto}`
      );
      if (res.status === 200) {
        setData2((prevData) => {
          let dataNew = prevData?.cropPhoto?.map((el) => {
            if (el.cropUploadPhoto === photo.cropUploadPhoto) {
              return { ...el, cropUploadPhoto: res.data.url };
            } else {
              return el;
            }
          });
          return { ...prevData, cropPhoto: dataNew };
        });
      }
    } catch (error) {
      console.error("Error fetching", error);
    }
  };
  const getBG = (date) => {
    let newDt = new Date().toISOString().split("T")[0];

    if (date == newDt) {
      return "bg-primary-lt";
    }
    return "";
  };
  const getScheduleBadge = (schedule) => {
    if (schedule === "Fertigation") {
      return (
        <p className="m-0 p-0">
          <span className="badge bg-yellow text-white m-1">Fertigation</span>{" "}
        </p>
      );
    }
    if (schedule === "Spray") {
      return (
        <p className="m-0 p-0">
          <span className="badge bg-green text-white m-1">Spray</span>
        </p>
      );
    }
    if (schedule === "Drenching") {
      return (
        <p className="m-0 p-0">
          <span className="badge bg-azure text-white m-1">Drenching</span>
        </p>
      );
    }
    if (schedule) {
      return (
        <p className="m-0 p-0">
          <span className="badge bg-danger text-white m-1">{schedule}</span>
        </p>
      );
    } else {
      return schedule;
    }
  };

  // useEffect(() => {
  //   if (data?.cropPhoto && data?.cropPhoto.length > 0) {
  //     for (let i = 0; i < data?.cropPhoto.length; i++) {
  //       // setTimeout(() => {
  //       getUplodedImage(data?.cropPhoto[i], i);
  //       // }, i * 1000);
  //     }
  //   }
  // }, [data]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <PiPottedPlantDuotone
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  Crop Schedule
                </h2>
                <h4 className="text-muted">Track & manage your crops.</h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/farm-crop-schedule"} className="btn btn-primary">
                    {" "}
                    <PiPottedPlantDuotone className="fs-3 me-2" />
                    ALL Schedules
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card table-responsive">
                <table className="table table-striped table-vcenter">
                  <thead>
                    <tr>
                      <th>Specs</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                      data && (
                        <tr>
                          <td>Project Name</td>
                          <td>{(data?.farmName || "N/A").toUpperCase()}</td>
                        </tr>
                      )}
                    {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                      data && (
                        <tr>
                          <td>Project Address</td>
                          <td>
                            {(data?.projectAddress || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                    {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                      data && (
                        <tr>
                          <td>Contact</td>
                          <td>
                            {(data?.clientPhoneNumber || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                    {data && (
                      <tr>
                        <td>Cycle Name</td>
                        <td>{(data?.cropCycleName || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Crop Name</td>
                        <td>{(data?.cropName || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>System Type</td>
                        <td>{(data?.typeOfSystem || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>CEA System Type</td>
                        <td>{(data?.ceaSystem || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Tank Capacity</td>
                        <td>
                          {(data?.waterTankCapacity || "N/A").toUpperCase()}
                        </td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Crop Cycle Startdate</td>
                        <td>
                          {(data.cropCycleStartDate || "N/A").toUpperCase()}
                        </td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Total Crop Count</td>
                        <td>{(data?.totalCropCount || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data2 && (
                  <div className="table-responsive">
                    <table className="fs-5 table table-vcenter table-hover mb-0">
                      <thead>
                        <tr>
                          <th className="text-nowrap">Day</th>

                          {data2.typeOfSystem === "growBags" && (
                            <th className="text-nowrap">
                              Date / Activity / pH / EC
                            </th>
                          )}

                          {data2.typeOfSystem !== "growBags" && (
                            <th className="text-nowrap">
                              Date / Tank Maintenance / pH / EC
                            </th>
                          )}

                          <th className="text-nowrap">Operations</th>
                          <th className="text-nowrap">Photo</th>

                          {/* Wider Notes column */}
                          <th>Notes</th>

                          <th className="text-nowrap">Done</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data2?.cropPhoto?.map((lineItem, index) => (
                          <tr className={getBG(lineItem.date)} key={index}>
                            {/* DAY */}
                            <td>
                              <span className="badge bg-blue-lt">
                                Day {lineItem.Day}
                              </span>
                            </td>

                            {/* DATE / ACTIVITY */}
                            {data2.typeOfSystem === "growBags" && (
                              <td>
                                <div className="fw-semibold">
                                  {lineItem.date}
                                </div>

                                <div className="mt-1">
                                  {getScheduleBadge(lineItem.Activity)}
                                </div>

                                <div className="d-flex flex-column gap-1">
                                  <span className="badge bg-azure-lt">
                                    pH: {lineItem.pH || "-"}
                                  </span>

                                  <span className="badge bg-purple-lt">
                                    EC: {lineItem.EC || "-"}
                                  </span>
                                </div>
                              </td>
                            )}

                            {data2.typeOfSystem !== "growBags" && (
                              <td>
                                <div className="fw-semibold">
                                  {lineItem.date}
                                </div>

                                <div className="mt-1">
                                  {getScheduleBadge(lineItem.tankMaintenance)}
                                </div>
                                {/* PH / EC */}
                                <div className="d-flex flex-column gap-1">
                                  <span className="badge bg-azure-lt">
                                    pH: {lineItem.pH || "-"}
                                  </span>

                                  <span className="badge bg-purple-lt">
                                    EC: {lineItem.EC || "-"}
                                  </span>
                                </div>
                              </td>
                            )}

                            {/* OPERATIONS */}
                            <td>
                              <div className="fw-semibold">
                                {lineItem.Timer || "-"}
                              </div>

                              <div className="text-orange mt-1">
                                {data2.typeOfSystem === "growBags"
                                  ? lineItem.Composition || "-"
                                  : lineItem.spraySchedule || "-"}
                              </div>
                            </td>

                            {/* PHOTO */}
                            <td>
                              {lineItem?.cropUploadPhoto ? (
                                <span
                                  data-bs-toggle="modal"
                                  data-bs-target="#modal-scrollable"
                                  onClick={() =>
                                    setImageInfo({
                                      url: lineItem.cropUploadPhoto,
                                    })
                                  }
                                >
                                  <LazyImageComponent
                                    src={lineItem.cropUploadPhoto}
                                    alt="Crop"
                                  />
                                </span>
                              ) : (
                                <span className="text-secondary">N/A</span>
                              )}
                            </td>

                            {/* NOTES */}
                            <td>
                              {lineItem?.note ? (
                                <div className="text-wrap">{lineItem.note}</div>
                              ) : (
                                <span className="text-secondary">No notes</span>
                              )}
                            </td>

                            {/* DONE */}
                            <td>
                              {lineItem.scheduleDone ? (
                                <div className="text-center gap-2">
                                  <FaCheckCircle
                                    fontSize="20px"
                                    color="#34A853"
                                  />
                                  <div className="text-success fw-semibold">
                                    Done
                                  </div>

                                  {lineItem.scheduleDoneDate && (
                                    <div
                                      style={{ width: "70px" }}
                                      className="text-secondary small"
                                    >
                                      {lineItem.scheduleDoneDate}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="text-center gap-2">
                                  <FaCircleXmark
                                    fontSize="20px"
                                    color="#D80001"
                                  />

                                  <div className="text-danger fw-semibold">
                                    Pending
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton
                      buttonText="Update Schedule"
                      href={`/farm-crop-schedule/edit/${id}`}
                    />

                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-scrollable"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{imageInfo.name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body p-4">
                <LazyImageComponent
                  width={700}
                  src={imageInfo.url}
                  alt="not uploaded"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewCropUpdate;
